export const staticData = {
  title: '',
  description:
    'Với đội ngũ chuyên gia phân tích dữ liệu hàng đầu, sự kết hợp giữa trí tuệ thiên tạo (NI) và trí tuệ nhân tạo (AI) cùng năng lực ứng dụng các công cụ phân tích dữ liệu hiện đại, Vietstats đặt mục tiêu trở thành nhà cung cấp dữ liệu kinh tế, nhà phân tích dữ liệu kinh tế và là nhà tư vấn chính sách kinh tế, tài chính và thị trường uy tín, chuyên nghiệp hàng đầu Việt Nam dựa trên tài nguyên dữ liệu lớn về kinh tế của Vietstats.',
};

export const localeVN = {
  lang: {
    locale: 'vi_VN',
    yearPlaceholder: 'Chọn năm',
    quarterPlaceholder: 'Chọn quý',
    monthPlaceholder: 'Chọn tháng',
    weekPlaceholder: 'Chọn tuần',
    rangePlaceholder: ['Ngày bắt đầu', 'Ngày kết thúc'],
    rangeYearPlaceholder: ['Năm bắt đầu', 'Năm kết thúc'],
    rangeQuarterPlaceholder: ['Quý bắt đầu', 'Quý kết thúc'],
    rangeMonthPlaceholder: ['Tháng bắt đầu', 'Tháng kết thúc'],
    rangeWeekPlaceholder: ['Tuần bắt đầu', 'Tuần kết thúc'],
    today: 'Hôm nay',
    now: 'Bây giờ',
    backToToday: 'Back to today',
    ok: 'Lưu',
    clear: 'Xóa',
    month: 'Tháng',
    year: 'Năm',
    timeSelect: 'Chọn thời gian',
    dateSelect: 'Chọn ngày',
    weekSelect: 'Chọn tuần',
    monthSelect: 'Chọn tháng',
    yearSelect: 'Chọn năm',
    decadeSelect: 'Chọn thập kỷ',
    yearFormat: 'YYYY',
    dateFormat: 'DD-MM-YYYY',
    dayFormat: 'DD',
    dateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
    monthBeforeYear: true,
    previousMonth: 'Tháng trước (PageUp)',
    nextMonth: 'Tháng sau (PageDown)',
    previousYear: 'Năm trước (Control + left)',
    nextYear: 'Năm sau (Control + right)',
    previousDecade: 'Thập kỷ trước',
    nextDecade: 'Thập kỷ sau',
    previousCentury: 'Thế kỷ trước',
    nextCentury: 'Thế kỷ sau',
    shortWeekDays: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    shortMonths: [
      'Tháng 1',
      'Tháng 2',
      'Tháng 3',
      'Tháng 4',
      'Tháng 5',
      'Tháng 6',
      'Tháng 7',
      'Tháng 8',
      'Tháng 9',
      'Tháng 10',
      'Tháng 11',
      'Tháng 12',
    ],
  },
  timePickerLocale: {
    placeholder: 'Chọn thời gian',
    rangePlaceholder: ['Bắt đầu', 'Kết thúc'],
  },
  dateFormat: 'DD-MM-YYYY',
  dateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
  weekFormat: 'wo-YYYY',
  monthFormat: 'MM-YYYY',
};

export const itemsMenu = [
  // { key: 'downloadCSV', label: 'Tải xuống dưới dạng CSV' },
  { key: 'downloadPNG', label: ' Tải xuống dưới dạng PNG' },
  { key: 'downloadJPEG', label: 'Tải xuống dưới dạng JPEG' },
  { key: 'downloadPDF', label: 'Tải xuống dưới dạng PDF' },
  { key: 'downloadSVG', label: 'Tải xuống dưới dạng SVG' },
  { key: 'downloadXLS', label: 'Tải xuống dưới dạng Excel' },
];

export const PATH_URL = {
  ARTICLE_URL: '/con-so-biet-noi',
  INDICATOR_URL: '/du-lieu-kinh-te',
  INDUSTRY_URL: '/kinh-te-nganh',
  LOCAL_URL: '/kinh-te-dia-phuong',
  SEARCH_URL: '/tim-kiem',
  CAREER: '/co-hoi-nghe-nghiep',
  ECONOMIC_REPORTS: '/tai-nguyen',
};

export const addonMapping: Record<any, string> = {
  // view_data_without_details: 'Xem dữ liệu',
  search_unlimited_data: 'Search tìm dữ liệu',
  trend_image_daily_data_unlimit_slot: 'Download hình Con số biết nói',
  view_optional_chart: 'Chọn kiểu đồ thị',
  receive_notification_and_reminder_updated_data:
    'Nhận thông báo và nhắc nhở dữ liệu cập nhật',
  view_data_details: 'Dữ liệu chi tiết',
  excel_add_in: 'Excel Add-ins',
  tools_and_forecast: 'Công cụ và Dự báo',
  // websockets_real_time: 'Web Sockets/Real-time', // chua co
  compare_data: 'So sánh chỉ số',
};

export const addonDataAI: Record<any, string> = {
  ai_data_analysis_10_request: 'Giới hạn 10 yêu cầu',
  ai_data_analysis_50_request: 'Giới hạn 50 yêu cầu',
  ai_data_analysis_200_request: 'Giới hạn 200 yêu cầu',
};

export const addonDownloadExcel: Record<any, string> = {
  trend_forecast: 'Download data chi tiết (Excel/CSV) (49,000VND/lượt)',
  trend_forecast_10_slot: '10 lượt/tháng',
  trend_forecast_50_slot: '50 lượt/tháng',
  trend_forecast_100_slot: '100 lượt/tháng',
  trend_forecast_200_slot: '200 lượt/tháng',
  trend_forecast_unlimit_slot: 'Không hạn chế',
};

export const addonViewIndicatorOnChart: Record<any, string> = {
  view_last_12_periods: 'Tối đa 12 kỳ gần nhất',
  view_unlimited_data: 'Không hạn chế',
};

export const addonDownloadPNGJPEG: Record<any, string> = {
  trend_image_pdf_12_slot: '12 lượt/tháng',
  trend_image_pdf_60_slot: '60 lượt/tháng',
  trend_image_pdf_120_slot: '120 lượt/tháng',
  trend_image_pdf_unlimit_slot: 'Không hạn chế',
};

export const addonDownloadPDFSVG: Record<any, string> = {
  trend_pdf_svg_12_slot: '12 lượt/tháng',
  trend_pdf_svg_60_slot: '60 lượt/tháng',
  trend_pdf_svg_120_slot: '120 lượt/tháng',
  trend_pdf_svg_unlimit_slot: 'Không hạn chế',
};

export const addonLogin: Record<any, string> = {
  mutible_login_one: '1 người dùng',
  mutible_login_three: '3 người dùng',
  mutible_login_five: '10 người dùng',
  mutible_login_ten: '10 người dùng',
};
export const addonRestAPI: Record<any, string> = {
  rest_api_indices_5_fields: 'API (tùy chọn 5 lĩnh vực)',
  rest_api_indices_unlimit_fields: 'API (lên đến hơn 25 lĩnh vực)',
};
export const addonDownloadReport: Record<any, string> = {
  download_free_analysis_report: 'Download báo cáo phân tích',
  download_free_analysis_some_report: 'Một số báo cáo',
};

export const addonDownloadDataset: Record<any, string> = {
  dataset_10_slot: '10 lượt/tháng',
  dataset_20_slot: '20 lượt/tháng',
  dataset_unlimit_slot: 'Không hạn chế',
};

export const plan_prices = [
  // vãng lai
  [
    {
      name: '1 Tháng',
      price: null,
    },
    {
      name: '1 Quý (giảm 10%)',
      price: null,
    },
    {
      name: '6 Tháng (giảm 15%)',
      price: null,
    },
    {
      name: '1 Năm (giảm 20%)',
      price: null,
    },
  ],
  // login
  [
    {
      name: '1 Tháng',
      price: '0',
    },
    {
      name: '1 Quý (giảm 10%)',
      price: '0',
    },
    {
      name: '6 Tháng (giảm 15%)',
      price: '0',
    },
    {
      name: '1 Năm (giảm 20%)',
      price: '0',
    },
  ],
  // basic
  [
    {
      name: '1 Tháng',
      price: '390,000',
    },
    {
      name: '1 Quý (giảm 10%)',
      price: '351,000',
    },
    {
      name: '6 Tháng (giảm 15%)',
      price: '331,500',
    },
    {
      name: '1 Năm (giảm 20%)',
      price: '312,000',
    },
  ],
  // standard
  [
    {
      name: '1 Tháng',
      price: '790,000',
    },
    {
      name: '1 Quý (giảm 10%)',
      price: '711,000',
    },
    {
      name: '6 Tháng (giảm 15%)',
      price: '671,500',
    },
    {
      name: '1 Năm (giảm 20%)',
      price: '632,000',
    },
  ],
  // premium
  [
    {
      name: '1 Tháng',
      price: '1,990,000',
    },
    {
      name: '1 Quý (giảm 10%)',
      price: '1,791,000',
    },
    {
      name: '6 Tháng (giảm 15%)',
      price: '1,691,500',
    },
    {
      name: '1 Năm (giảm 20%)',
      price: '1,592,000',
    },
  ],
  // pro
  [
    {
      name: '1 Tháng',
      price: '3,990,000',
    },
    {
      name: '1 Quý (giảm 10%)',
      price: '3,591,000',
    },
    {
      name: '6 Tháng (giảm 15%)',
      price: '3,391,500',
    },
    {
      name: '1 Năm (giảm 20%)',
      price: '3,192,000',
    },
  ],
];

export const provinceOrder = [
  'Hà Nội',
  'Vĩnh Phúc',
  'Bắc Ninh',
  'Quảng Ninh',
  'Hải Dương',
  'TP. Hải Phòng',
  'Hưng Yên',
  'Thái Bình',
  'Hà Nam',
  'Nam Định',
  'Ninh Bình',
  'Hà Giang',
  'Cao Bằng',
  'Bắc Kạn',
  'Tuyên Quang',
  'Lào Cai',
  'Yên Bái',
  'Thái Nguyên',
  'Lạng Sơn',
  'Bắc Giang',
  'Phú Thọ',
  'Điện Biên',
  'Lai Châu',
  'Sơn La',
  'Hòa Bình',
  'Thanh Hóa',
  'Nghệ An',
  'Hà Tĩnh',
  'Quảng Bình',
  'Quảng Trị',
  'TP. Huế',
  'TP. Đà Nẵng',
  'Quảng Nam',
  'Quảng Ngãi',
  'Bình Định',
  'Phú Yên',
  'Khánh Hòa',
  'Ninh Thuận',
  'Bình Thuận',
  'Kon Tum',
  'Gia Lai',
  'Đắk Lắk',
  'Đắk Nông',
  'Lâm Đồng',
  'Bình Phước',
  'Tây Ninh',
  'Bình Dương',
  'Đồng Nai',
  'Bà Rịa - Vũng Tàu',
  'TP. Hồ Chí Minh',
  'Long An',
  'Tiền Giang',
  'Bến Tre',
  'Trà Vinh',
  'Vĩnh Long',
  'Đồng Tháp',
  'An Giang',
  'Kiên Giang',
  'TP. Cần Thơ',
  'Hậu Giang',
  'Sóc Trăng',
  'Bạc Liêu',
  'Cà Mau',
];

export const listQualityOrder = [
  { id: 1, label: '1 Tháng', value: 'monthly' },
  { id: 3, label: '3 Tháng', value: 'quarter' },
  { id: 6, label: '6 Tháng', value: 'halfYear' },
  { id: 12, label: '12 Tháng', value: 'year' },
];

export const discountCaculate: Record<string, number> = {
  '1': 0,
  '3': 10,
  '6': 15,
  '12': 20,
};

export const discountOptions: Record<string, number> = {
  monthly: 0,
  quarter: 10,
  halfYear: 15,
  year: 20,
};

export const jobList = [
  { value: 'Data Analyst', label: 'Data Analyst' },
  { value: 'Bác sĩ', label: 'Bác sĩ' },
  { value: 'Lập trình viên', label: 'Lập trình viên' },
  { value: 'Giáo viên', label: 'Giáo viên' },
  { value: 'Viên chức nhà nước', label: 'Viên chức nhà nước' },
  { value: 'Sinh viên', label: 'Sinh viên' },
  { value: 'Nghiên cứu sinh', label: 'Nghiên cứu sinh' },
  { value: 'Kế toán', label: 'Kế toán' },
  { value: 'Nhân viên kinh doanh', label: 'Nhân viên kinh doanh' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Thiết kế đồ họa', label: 'Thiết kế đồ họa' },
  { value: 'Luật sư', label: 'Luật sư' },
  { value: 'Kỹ sư', label: 'Kỹ sư' },
  { value: 'Chuyên viên nhân sự', label: 'Chuyên viên nhân sự' },
  { value: 'Bán hàng', label: 'Bán hàng' },
  { value: 'Người sáng tạo nội dung', label: 'Người sáng tạo nội dung' },
  { value: 'Tư vấn viên', label: 'Tư vấn viên' },
  { value: 'Nhà báo', label: 'Nhà báo' },
  { value: 'Chuyên gia tài chính', label: 'Chuyên gia tài chính' },
  { value: 'Quản lý dự án', label: 'Quản lý dự án' },
];

export const mimeTypes: Record<string, string> = {
  txt: 'text/plain',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  csv: 'text/csv',
  rar: 'application/x-rar-compressed',
  zip: 'application/zip',
};
